<template>
  <div>
    <template v-if="!isLoading">
      <b-avatar
        size="35px"
        variant="primary"
        :badge-variant="userInfo.variant"
        :text="userInfo.userInitials"
        :src="userInfo.avatar"
      ></b-avatar>
    </template>
    <b-skeleton type="avatar" v-else></b-skeleton>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      userInfo: null
    }
  },
  methods: {
    async loadUserInfo () {
      const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${this.value}`)
      this.userInfo = {
        id: res.data.id,
        name: `${res.data.firstname} ${res.data.lastname}`,
        userInitials: res.data?.userInitials,
        avatar: res.data?.profilePicture || ''
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      await this.loadUserInfo()
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
